/**
 * TanStack Query hooks for `export-to-csv-xlsx`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	exportToCsvXlsxQueryKeys,
	type CreateExportToCsvXlsxBody,
	type ListExportToCsvXlsxResponse,
	type ExportToCsvXlsxRow,
} from "./api";

export function useExportToCsvXlsxList(): UseQueryResult<ListExportToCsvXlsxResponse, Error> {
	return useQuery({
		queryKey: exportToCsvXlsxQueryKeys.list(),
		queryFn: list,
	});
}

export function useExportToCsvXlsxCreate(): UseMutationResult<ExportToCsvXlsxRow, Error, CreateExportToCsvXlsxBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: exportToCsvXlsxQueryKeys.all });
		},
	});
}

export function useExportToCsvXlsxDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: exportToCsvXlsxQueryKeys.all });
		},
	});
}
